import { computed } from "@ember/object";
import { service } from "@ember/service";
import { classNames } from "@ember-decorators/component";
import { uniqueItemsFromArray } from "discourse/lib/array-tools";
import { bind } from "discourse/lib/decorators";
import { makeArray } from "discourse/lib/helpers";
import MultiSelectComponent from "select-kit/components/multi-select";
import { pluginApiIdentifiers, selectKitOptions } from "select-kit/components/select-kit";
import TagChooserRow from "./tag-chooser-row";
const TagGroupChooser = dt7948.c(class TagGroupChooser extends MultiSelectComponent {
  static {
    dt7948.g(this.prototype, "tagUtils", [service]);
  }
  #tagUtils = (dt7948.i(this, "tagUtils"), void 0);
  modifyComponentForRow() {
    return TagChooserRow;
  }
  get value() {
    return uniqueItemsFromArray(makeArray(this.tagGroups));
  }
  static {
    dt7948.n(this.prototype, "value", [computed("tagGroups.[]")]);
  }
  get content() {
    return uniqueItemsFromArray(makeArray(this.tagGroups)).map(t => this.defaultItem(t, t));
  }
  static {
    dt7948.n(this.prototype, "content", [computed("tagGroups.[]")]);
  }
  validateCreate(filter, content) {
    return this.tagUtils.validateCreate(filter, content, this.selectKit.options.maximum, e => this.addError(e), this.termMatchesForbidden, value => this.getValue(value), this.value);
  }
  createContentFromInput(input) {
    return this.tagUtils.createContentFromInput(input);
  }
  search(query) {
    const data = {
      q: query,
      limit: this.siteSettings.max_tag_search_results
    };
    return this.tagUtils.searchTags("/tag_groups/filter/search", data, this._transformJson).then(results => {
      if (results && results.length) {
        return results.filter(r => {
          return !makeArray(this.tagGroups).includes(this.getValue(r));
        });
      }
    });
  }
  _transformJson(json) {
    if (this.isDestroyed || this.isDestroying) {
      return [];
    }
    return json.results.sort((a, b) => a.name > b.name).map(result => {
      return {
        id: result.name,
        name: result.name,
        count: result.count
      };
    });
  }
  static {
    dt7948.n(this.prototype, "_transformJson", [bind]);
  }
}, [pluginApiIdentifiers("tag-group-chooser"), selectKitOptions({
  allowAny: false,
  filterable: true,
  filterPlaceholder: "category.tag_groups_placeholder",
  limit: null
}), classNames("tag-group-chooser", "tag-chooser")]);
export default TagGroupChooser;